const development = {
  name: 'development',
  url: 'http://localhost:3000',
  domain: 'localhost',
  API_END_POINT: 'http://localhost:3001',
  logging: {
    prefix: 'legal-web-app-client-develop-',
    file: {
      enable: false,
      path: `${__dirname}/../logs`,
    },
    fluentd: {
      enable: false,
    },
    cloudwatch: {
      enable: false,
    },
  },
  cognito: {
    region: 'ap-northeast-1',
    userPoolId: 'ap-northeast-1_qY7w7h66h',
    clientId: '1pvd9jk8mib50tv0n7dahloh2i',
    identityPoolId: 'ap-northeast-1:d2114fd8-d64b-4c57-8e8d-368b9d39a237',
  },
  s3: {
    region: 'ap-northeast-1',
    bucket: 'develop-legal-web-app.orso-x-sensing.jp',
  },
  stripe: {
    publicKey: 'pk_test_51GweuEIEG6RZAcT8eY18RaNzbZkyContkcmViELq4RCNANuBoPxLIwMVbiXOoyTGkKZxP69px1qbNuQfn6VBx5ry00GG5HMHQH',
  },
  paid: {
    cid: '1193084',
  },
  PORT_NUMBER: 3000,
}
const staging = {
  name: 'staging',
  url: 'https://staging-app.minnano-keiyakusho.jp',
  domain: 'staging-app.minnano-keiyakusho.jp',
  API_END_POINT: 'https://staging-app-api.minnano-keiyakusho.jp',
  logging: {
    prefix: 'staging-legal-app-client-',
    file: {
      enable: false,
      path: `${__dirname}/../logs`,
    },
    fluentd: {
      enable: false,
    },
    cloudwatch: {
      enable: true,
    },
  },
  cognito: {
    region: 'ap-northeast-1',
    userPoolId: 'ap-northeast-1_aE4gGAtsB',
    clientId: '79vcvgvib0o9e0as8npeu4m0to',
    identityPoolId: 'ap-northeast-1:a34ce243-8e05-4602-8f4d-b10f6956e26a',
  },
  s3: {
    region: 'ap-northeast-1',
    bucket: 'staging.minnano-keiyakusho.jp',
  },
  stripe: {
    publicKey: 'pk_test_51TC9otIK4AyQcTgylN4XPDKZR9KIdh2R600Ozb6zerFtkWjZeYils2ktrB9qghhzNehg00Wtp96FbN2tPZOw1Vxi00FzBIVkLq',
  },
  paid: {
    cid: '1193084',
  },
  PORT_NUMBER: 3000,
}
const production = {
  name: 'production',
  url: 'https://app.minnano-keiyakusho.jp',
  domain: 'app.minnano-keiyakusho.jp',
  API_END_POINT: 'https://app-api.minnano-keiyakusho.jp',
  logging: {
    prefix: 'production-legal-app-client-',
    file: {
      enable: false,
      path: `${__dirname}/../logs`,
    },
    fluentd: {
      enable: false,
    },
    cloudwatch: {
      enable: true,
    },
  },
  cognito: {
    region: 'ap-northeast-1',
    userPoolId: 'ap-northeast-1_REqPQeaGN',
    clientId: '45u341ndvkk9sabnf6j281ga37',
    identityPoolId: 'ap-northeast-1:726dcb62-f081-4617-893a-d09ad8e0b98e',
  },
  s3: {
    region: 'ap-northeast-1',
    bucket: 'production.minnano-keiyakusho.jp',
  },
  stripe: {
    publicKey: 'pk_live_51TC9otIK4AyQcTgyRFdHgs1EtlTMVEY8DB8NdFPRJIqTqgcI2LDDCSNMd3i6IapF6NT7rUH0t0BkhaVxOpXD55eG00n2qDmySC',
  },
  paid: {
    cid: '1192968',
  },
  PORT_NUMBER: 3000,
}

if (process.env.ENV === 'development') {
  module.exports = development
} else if (process.env.ENV === 'staging') {
  module.exports = staging
} else if (process.env.ENV === 'production') {
  module.exports = production
}
